import { render, staticRenderFns } from "./zhsysManagePlatform.vue?vue&type=template&id=15330a4c&scoped=true"
import script from "./zhsysManagePlatform.vue?vue&type=script&lang=js"
export * from "./zhsysManagePlatform.vue?vue&type=script&lang=js"
import style0 from "./zhsysManagePlatform.vue?vue&type=style&index=0&id=15330a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15330a4c",
  null
  
)

export default component.exports